import React from 'react'
import './styles.css'

// `contained` alinha o conteudo ao container central da home, como o Header.
export default function Footer({ contained }) {
  return (
    <footer className={`container-footer${contained ? ' container-footer-contained' : ''}`}>
      <div className='container-footer-inner'>
        <span className='container-footer-brand'>Sobre Rodas</span>
        <p className='container-footer-copy-right'>
          © {new Date().getFullYear()} Work Inteligência
        </p>
      </div>
    </footer>
  )
}
